/* eslint-disable import/no-anonymous-default-export */
export default (api) => {

    const placeBid = (payload) => {
        return api.post('/v1/auction/place-bid', payload);
    };

    const fetchBidDetails = (auctionId) => {
        return api.get(`/v1/auction/current-bid/${auctionId}`);
    };
    return {
        placeBid,
        fetchBidDetails
    };
};
